<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle consigne</strong>
          </div>
          <b-form>
            <b-form-group label="Garantie">
              <multiselect v-model="selectedGaranties"
                selectLabel='Appuyer sur entrer pour sélectionner' 
                selectedLabel='Sélectionné' 
                deselectLabel='Appuyer sur entrer pour désélectionner'
                :close-on-select="false"
                tag-placeholder="Choisissez une garantie"
                placeholder="Choisissez une garantie"
                label="text"
                track-by="value"
                :options="allGaranties"
                :multiple="true"
                :taggable="true">
              </multiselect>
            </b-form-group>
            <b-form-group label="Famille produit" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="famillesProduits"
                v-model="selectedFamilleProduit">
              </b-form-select>
              <span class="field-error">{{ errors.familleProduit }}</span>
            </b-form-group>
            <b-form-group>
              <label for="date_debut"><strong>Date début</strong></label>
              <b-form-input type="date" id="date_debut" v-model="date_debut"/>
              <span class="field-error">{{ errors.date_debut }}</span>
            </b-form-group>
            <b-form-group>
              <label for="date_fin"><strong>Date fin prévue</strong></label>
              <b-form-input type="date" id="date_fin" v-model="date_fin"/>
              <span class="field-error">{{ errors.date_fin }}</span>
            </b-form-group>
            <b-form-group
              label-for='nom_fichier1'>
              <template slot="label"><b>Pièces Jointes</b></template>
              <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                class="file-input"
                drop-placeholder="Déposer le(s) fichier(s) ici..."
                browse-text="Parcourir"
                :state="errors.consigneAttachments !== '' ? false : null"
                @change="addFileToConsigne($event)"
                multiple>
              </b-form-file>
              <b-row>
                <b-col sm="9"></b-col>
                <b-col sm="3" style="text-align:right">
                  Le nombre de pièces jointes est limité à : {{ maxPjConsigne }}
                </b-col>
              </b-row>
              <span class="field-error">{{ errors.consigneAttachments }}</span>
            </b-form-group>
            <b-form-group label="Commentaire" label-for="commentaire">
              <b-form-textarea
                id="commentaire"
                type="text"
                :class="{hasError: errors.commentaire !== ''}"
                rows="3"
                max-rows="6"
                v-model="commentaire">
              </b-form-textarea>
              <span class="field-error">{{ errors.commentaire }}</span>
            </b-form-group>

            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des consignes
              </b-button>
              <b-button type="button" @click="save('stay')" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
              <b-button type="button" @click="save('quit')" size="md" class="pull-right mr-2" variant="warning">
                <i class="fa fa-save"/> Enregistrer et Quitter
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../../utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import {MAX_PJ_CONSIGNE} from '@/utils/constants';
  import Multiselect from 'vue-multiselect'

  export default {
    name: "Add",
    components: {
      Multiselect
    },
    data() {
      return {
        selectedFamilleProduit: null,
        commentaire: "",
        date_debut: '',
        date_fin: '',
        famillesProduits: [],
        consigneAttachments: null,
        maxPjConsigne: MAX_PJ_CONSIGNE,
        selectedGaranties: [],
        allGaranties: [],
        errors: {
          commentaire: "",
          familleProduit: "",
          consigneAttachments: '',
          date_debut: "",
          date_fin: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getFamillesProduits();
      this.getGarantiesConsignes();
    },
    methods: {
      getGarantiesConsignes() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-garanties')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const garanties = response.data.garanties;
            for (let i = 0; i < garanties.length; i++) {
              if (garanties[i].groupe !== 'DBCO') {
                this.allGaranties.push({
                  text: garanties[i].groupe,
                  value: garanties[i].groupe
                });
              }
            }
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      getFamillesProduits() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes/famille-produit')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const familles = response.data.data;
            for (let i = 0; i < familles.length; i++) {
              this.famillesProduits.push({
                text: familles[i].libelle,
                value: familles[i].id
              });
            }
          })
          .catch(() => {
            this.handleError(this);
          });
      },
      addFileToConsigne(event) {
        this.consigneAttachments = event.target.files;
      },
      save(type) {
        let self = this;
        if (this.validateData()) {
          let formData = new FormData();
          if (this.consigneAttachments) {
            for( var i = 0; i < this.consigneAttachments.length; i++ ){
              let file = this.consigneAttachments[i];
              formData.append('files[' + i + ']', file);
            }
          }
          formData.append('familleProduitId', this.selectedFamilleProduit);
          formData.append('commentaire', this.commentaire);
          formData.append('date_debut', this.date_debut);
          formData.append('date_fin', this.date_fin);
          formData.append('selectedGaranties', this.selectedGaranties.map((garantie) => garantie.value));

          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post("/espaceGestion/consignes-produits", formData)
            .then((response) => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "La consigne a été bien crée ",
                showConfirmButton: false,
                timer: 5000
              });
              if (type === 'quit') {
                this.returnBack()
              } else {
                this.$router.push({path: '/espace-gestion/consignes-produit/edit/' + response.data.consigne_id})
              }
            })
            .catch(() => {
              self.handleError(this);
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/consignes-produit/list"});
      },
      validateData() {
        this.clearErrors()
        let dateFrom = new Date(this.date_debut)
        let dateTo = new Date(this.date_fin)
        let valid = true;

        if (this.consigneAttachments && this.consigneAttachments.length > this.maxPjConsigne) {
          this.errors.consigneAttachments = "Le nombre de pièces jointes est limité à : " + this.maxPjConsigne
          valid = false
        }
        if (this.selectedFamilleProduit === null) {
          this.errors.familleProduit = "La famille produit est obligatoire";
          valid = false;
        }
        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = "La commentaire est obligatoire";
          valid = false;
        }
        if (!this.date_debut) {
            this.errors.date_debut = "La date de début est obligatoire"
            valid= false;
        }
        if (!this.date_fin) {
            this.errors.date_fin = "La date de fin est obligatoire"
            valid= false;
        }
        if (this.date_fin !== null && this.date_fin !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.date_fin = "La date de fin doit être postérieure à la date de début"
            valid= false;
          }
        }

        return valid;
      },
      clearErrors() {
        this.errors.familleProduit = "";
        this.errors.consigneAttachments = "";
        this.errors.date_fin = "";
      },
      handleError(self) {
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000
        });
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
